<template lang="pug">
#filtrar-monitoramento-socioambiental
    .filtrar-monitoramento-socioambiental-container
        .filtrar-monitoramento-socioambiental-input-container
            .filtrar-monitoramento-socioambiental__input
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    :placeholder='placeholderPais()',
                    autocomplete='off',
                    @keyup.enter='pesquisar',
                    @blur='fecharLista'
                )

            .filtrar-monitoramento-socioambiental__resultado
                transition(name='el-zoom-in-top')
                    ul.filtrar-monitoramento-socioambiental__ul(
                        v-if='mostrarResultado'
                    )
                        .mb-2(v-for='resultadoPesquisa in resultadosPesquisa')
                            span.filtrar-monitoramento-socioambiental__categoria(
                                v-if='resultadoPesquisa.resultado.length'
                            ) {{ resultadoPesquisa.categoria }}

                            li(
                                v-for='resultado in resultadoPesquisa.resultado',
                                @click='selecionarResultado(resultado)'
                            )
                                span {{ resultado.valor }}

        .filtrar-monitoramento-socioambiental__button
            el-popover(
                placement='bottom-start',
                width='750',
                trigger='click',
                popper-class='el-popover-monitoramento-socioambiental'
            )
                BaseButton.button-outline(
                    type='outline',
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    :plain='true',
                    slot='reference'
                ) {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}

                el-form.filtro(label-position='top')
                    .filtrar-monitoramento-socioambiental-popover-header
                        .filtrar-monitoramento-socioambiental-popover-header__text {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}
                        .filtrar-monitoramento-socioambiental-popover-header__link(
                            @click='aplicar'
                        )
                            | {{ $t('mensagens.blocoFiltros.uteis.aplicarFiltros') }}

                    .filtrar-monitoramento-socioambiental-popover-collapse
                        el-form-item.mb-0.filtro-accordion
                            el-collapse(
                                v-model='collapseFiltroAvancado',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(
                                    :title='$t("mensagens.blocoAlerta.filtros.filtroRestricaoSocioambiental")',
                                    name='restricaoSocioambiental'
                                )
                                    .el-collapse-restricoes--loading
                                        el-radio-group(
                                            v-model='possuiRestricao'
                                        )
                                            el-radio(label='POSSUI_RESTRICOES') {{ $t('mensagens.blocoAlerta.filtros.possuiRestricaoLabelFiltro') }}
                                            el-radio(
                                                label='NAO_POSSUI_RESTRICOES'
                                            ) {{ $t('mensagens.blocoAlerta.filtros.naoPossuiRestricaoLabelFiltro') }}

                                el-collapse-item(
                                    v-if="ambienteBr"
                                    :title='$t("mensagens.monitoramentoSocioambiental.bioma")',
                                    name='biomas'
                                )
                                    .el-collapse-item__biomas--loading(
                                        v-loading='!biomas.length'
                                    )
                                        el-checkbox-group(
                                            v-model='biomasSelecionados',
                                            :max='1'
                                        )
                                            el-checkbox(
                                                v-for='(bioma, index) in biomas',
                                                :label='bioma',
                                                :key='index',
                                                :title='bioma.nome'
                                            )
                                                | {{ bioma.nome }}

                                el-collapse-item(
                                    :title='$t("mensagens.blocoAlerta.filtros.filtroCriteriosSocioambientais")',
                                    name='camadasSocioAmbientais'
                                )
                                    .el-collapse-item__camadas-socioambientais--loading(
                                        v-loading='!camadasSocioAmbientais.length'
                                    )
                                        el-checkbox(
                                            :indeterminate='isIndeterminateAreasProtegidas',
                                            v-model='checkAllAreasProtegidas',
                                            @change='handleCheckAllAreasProtegidasChange'
                                        ) {{ $t('mensagens.blocoAlerta.filtros.filtroAreasProtegidas') }}
                                        el-checkbox-group(
                                            v-model='areasProtegidasSelecionadas',
                                            @change='handleAreasProtegidasSelecionadasChange'
                                        )
                                            el-checkbox(
                                                v-for='area in areasProtegidas',
                                                :label='area.codigoCamada',
                                                :key='area.id'
                                            ) {{ traduzirCamada(area.codigoCamada) }}

                                        el-divider

                                        el-checkbox(
                                            :indeterminate='isIndeterminateEmbargosDesmatamentos',
                                            v-model='checkAllEmbargosDesmatamentos',
                                            @change='handleCheckAllEmbargosDesmatamentosChange'
                                        ) {{ $t('mensagens.blocoAlerta.filtros.filtroEmbargosDesmatamento') }}
                                        el-checkbox-group(
                                            v-model='embargosDesmatamentosSelecionados',
                                            @change='handleEmbargosDesmatamentosSelecionadosChange'
                                        )
                                            el-checkbox(
                                                v-for='embargo in embargosDesmatamentos',
                                                :label='embargo.codigoCamada',
                                                :key='embargo.id'
                                            ) {{ traduzirCamada(embargo.codigoCamada) }}

                                        el-divider

                                        el-checkbox(
                                            v-if='!ambientePy',
                                            :indeterminate='isIndeterminateRepresentantes',
                                            v-model='checkAllRepresentantes',
                                            @change='handleCheckAllRepresentantesChange'
                                        ) {{ $t('mensagens.blocoAlerta.filtros.filtroPessoasLista') }}
                                        el-checkbox-group(
                                            v-model='representantesSelecionados',
                                            @change='handleRepresentantesSelecionadosChange'
                                        )
                                            el-checkbox(
                                                v-for='representante in representantes',
                                                :label='representante.codigoCamada',
                                                :key='representante.id'
                                            ) {{ traduzirCamada(representante.codigoCamada) }}

                                        el-divider(v-if='!ambientePy')

                                        el-checkbox(
                                            :indeterminate='isIndeterminateSocial',
                                            v-model='checkAllSocial',
                                            @change='handleCheckAllSocialChange'
                                        ) {{ $t('mensagens.blocoAlerta.filtros.filtroSocial') }}
                                        el-checkbox-group(
                                            v-model='socialSelecionados',
                                            @change='handleSocialSelecionadosChange'
                                        )
                                            el-checkbox(
                                                v-for='sc in social',
                                                :label='sc.codigoCamada',
                                                :key='sc.id'
                                            ) {{ traduzirCamada(sc.codigoCamada) }}

                                el-collapse-item(
                                    :title='$t("mensagens.blocoFiltros.uteis.ufMunicipio")',
                                    name='localidadesNivel0',
                                    style='padding-bottom: 10px'
                                )
                                    .filtrar-monitoramento-socioambiental-popover-collapse__select(
                                        v-loading='!localidadesNivel0.length'
                                    )
                                        div
                                            p {{ $t('mensagens.comuns.pais') }}
                                            el-select(
                                                v-model='localidadeNivel0Selecionada',
                                                filterable,
                                                value-key='id',
                                                @change='buscarLocalidadeNivel1()',
                                                :placeholder='$t("mensagens.comuns.selecione")'
                                            )
                                                el-option(
                                                    v-for='(localidadeNivel0, index) in localidadesNivel0',
                                                    :key='index',
                                                    :label='localidadeNivel0.nome',
                                                    :value='localidadeNivel0'
                                                ) {{ localidadeNivel0.nome }}
                                        div
                                            p {{ tituloLocalidadeNivel1 }}
                                            el-select(
                                                v-model='localidadeNivel1Selecionada',
                                                filterable,
                                                value-key='id',
                                                @change='buscarLocalidadeNivel2()',
                                                :placeholder='$t("mensagens.comuns.selecione")'
                                            )
                                                el-option(
                                                    v-for='(localidadeNivel1, index) in localidadesNivel1',
                                                    :key='index',
                                                    :label='localidadeNivel1.nome',
                                                    :value='localidadeNivel1'
                                                ) {{ localidadeNivel1.nome }}
                                        div
                                            p {{ tituloLocalidadeNivel2 }}
                                            el-select(
                                                v-model='localidadeNivel2Selecionada',
                                                filterable,
                                                value-key='id',
                                                :placeholder='$t("mensagens.comuns.selecione")'
                                            )
                                                el-option(
                                                    v-for='(localidadeNivel2, index) in localidadesNivel2',
                                                    :key='index',
                                                    :label='localidadeNivel2.nome',
                                                    :value='localidadeNivel2'
                                                ) {{ localidadeNivel2.nome }}

    .filtrar-monitoramento-socioambiental-filtro-selecionado
        span.filtrar-monitoramento-socioambiental-filtro-selecionado__titulo {{ $t('mensagens.blocoFiltros.uteis.filtrosSelecionados') }}
        el-tag.filtrar-monitoramento-socioambiental-filtro-selecionado__tag(
            v-for='tag in tags',
            :key='tag.nome',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ getNome(tag.nome, tag.valor, tag) }}

        el-tag.filtrar-monitoramento-socioambiental-filtro-selecionado__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) {{ $t('mensagens.blocoFiltros.uteis.limparFiltro') }}
            i.el-icon-delete

        span.filtrar-monitoramento-socioambiental-filtro-selecionado__nenhum(
            v-else
        ) {{ $t('mensagens.blocoFiltros.uteis.nenhumFiltroSelecionado') }}
</template>

<script>
import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';
import BiomaService from '@/services/BiomaService';
import LocalidadeService from '@/services/LocalidadeService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'FiltrarMonitoramentoSocioambiental',

    /**
     * Retorno
     *
     * atualizar-filtro-avancado:
     * {
     *   idBiomas: [],
     *   possuiAlertas: String -> 'POSSUI' || 'NAO_POSSUI'
     *   idCategoriasFiltroAvancado: [],
     *   idRepresentantes: [],
     *   idTerritorios: []
     * }
     *
     */
    components: {
        BaseButton
    },
    emits: ['atualizar-filtro-avancado', 'remover-categoria-selecionada'],
    props: {
        categoria: {
            type: Object,
            default: () => null
        },
        filtroAlerta: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState(['usuarioLogado']),
        ...mapGetters(['ambientePy'])
    },
    data() {
        return {
            pesquisa: '',
            tags: [],
            collapseFiltroAvancado: [''],
            biomas: [],
            biomasSelecionados: [],
            possuiRestricao: null,
            idCamadas: [],
            idCamadasRepresentantes: [],
            camadasSocioAmbientais: [],
            checkAllAreasProtegidas: false,
            isIndeterminateAreasProtegidas: false,
            areasProtegidas: [],
            areasProtegidasSelecionadas: [],
            checkAllEmbargosDesmatamentos: false,
            isIndeterminateEmbargosDesmatamentos: false,
            embargosDesmatamentos: [],
            embargosDesmatamentosSelecionados: [],
            checkAllRepresentantes: false,
            isIndeterminateRepresentantes: false,
            representantes: [],
            representantesSelecionados: [],
            checkAllSocial: false,
            isIndeterminateSocial: false,
            social: [],
            socialSelecionados: [],
            localidadesNivel0: [],
            localidadeNivel0Selecionada: {},
            tituloLocalidadeNivel1: this.$t('mensagens.blocoFiltros.uteis.uf'),
            localidadesNivel1: [],
            localidadeNivel1Selecionada: {},
            tituloLocalidadeNivel2: this.$t('mensagens.blocoFiltros.uteis.municipio'),
            localidadesNivel2: [],
            localidadeNivel2Selecionada: {},
            resultadosPesquisa: [],
            resultadosSelecionados: [],
            mostrarResultado: false,
            acaoCollapse: {
                biomas: {
                    collapse: 'biomas',
                    callback: 'buscarBioma'
                },
                localidadesNivel0: {
                    collapse: 'localidadesNivel0',
                    callback: 'buscarLocalidadeNivel0'
                },
                localidadesNivel1: {
                    collapse: 'localidadesNivel1',
                    callback: 'buscarLocalidadeNivel1'
                },
                camadasSocioAmbientais: {
                    collapse: 'camadasSocioAmbientais',
                    callback: 'buscarCamadasSocioambientais'
                }
            },
            categorias: [],
            restricaoSocioambientalSelecionadas: null
        };
    },
    watch: {
        categoria: function () {
            if (this.categoria !== null) {
                // Categoria selecionada
                if (this.categoria.classe !== '') {
                    let categoriaJaSelecionada = this.categorias.filter(
                        c => c.id === this.categoria.id
                    );

                    if (
                        !categoriaJaSelecionada ||
                        categoriaJaSelecionada.length === 0
                    ) {
                        this.categorias.push({
                            nome: this.categoria.nome,
                            codigo: 'CATEGORIA',
                            id: this.categoria.id
                        });
                    }
                    // Categoria desmarcada
                } else {
                    this.categorias = this.categorias.filter(
                        c => c.id !== this.categoria.id
                    );
                    this.tags = this.tags.filter(
                        tag => tag.nome !== this.categoria.nome
                    );
                }

                for (let tag of this.tags) {
                    if (tag && tag.codigo === 'CATEGORIA') {
                        this.tags = this.tags.filter(
                            value => value.codigo !== 'CATEGORIA'
                        );
                    }
                }

                this.tags = [...this.tags, ...this.categorias];
            }
        },

        filtroAlerta: function () {
            if (this.filtroAlerta === true) {
                this.possuiRestricao = 'POSSUI_RESTRICOES';
                setTimeout(() => {
                    this.aplicar();
                }, 800);
            }
        },

        '$i18n.locale': function(newLocale) {
            this.internacionalizarLocalidade();
        }
    },
    methods: {
        async pesquisar() {
            if (!this.pesquisa) return this.limpar();

            try {
                const { data } =
                    await MonitoramentoSocioambientalService.pesquisar(
                        this.pesquisa
                    );
                this.resultadosPesquisa = data;

                if (!data.length) {
                    this.mostrarResultado = false;
                    this.exibirNotify(
                        'warning',
                        'Não foram encontrados resultados com o texto informado. Verifique a informação inserida ou inicie um novo monitoramento.'
                    );
                } else {
                    this.mostrarResultado = true;
                }
            } catch (error) {
                this.exibirNotify(
                    'error',
                    'Não foi possível filtrar os dados de monitoramento.'
                );
                throw error;
            }
        },

        aplicar() {
            this.handleIdCamadas();
            this.handleIdCamadasRepresentantes();

            let possuiRestricao =
                this.possuiRestricao === 'POSSUI_RESTRICOES'
                    ? true
                    : this.possuiRestricao === 'NAO_POSSUI_RESTRICOES'
                    ? false
                    : null;
            const filtros = {
                possuiRestricao: possuiRestricao,
                idBiomas: this.biomasSelecionados.map(b => b.id),
                idCamadas: this.idCamadas,
                idCamadasRepresentantes: this.idCamadasRepresentantes,
                idTerritorios: this.resultadosSelecionados
                    .map(t => t.filtro.idTerritorio)
                    .filter(t => t),
                idRepresentantes: this.resultadosSelecionados
                    .map(r => r.filtro.idRepresentante)
                    .filter(r => r)
            };

            this.tags = [
                ...this.biomasSelecionados,
                ...this.resultadosSelecionados,
                ...this.categorias
            ];

            if (this.localidadeNivel0Selecionada && this.localidadeNivel0Selecionada.id) {
                const localidadeNivel0 = {
                    id: this.localidadeNivel0Selecionada.id,
                    nome: `${this.localidadeNivel0Selecionada.sigla}`,
                    codigo: 'LOCALIDADE0'
                };
                this.tags.push(localidadeNivel0);
                filtros.idNivel0 = this.localidadeNivel0Selecionada.id;
            } else {
                filtros.idNivel0 = '';
            }

            if (this.localidadeNivel1Selecionada && this.localidadeNivel1Selecionada.id) {
                const localidadeNivel1 = {
                    id: this.localidadeNivel1Selecionada.id,
                    nome: `${this.localidadeNivel1Selecionada.sigla}`,
                    codigo: 'LOCALIDADE1'
                };
                this.tags.push(localidadeNivel1);
                filtros.idNivel1 = this.localidadeNivel1Selecionada.id;
            } else {
                filtros.idNivel1 = '';
            }

            if (this.localidadeNivel2Selecionada && this.localidadeNivel2Selecionada.id) {
                const localidadeNivel2 = {
                    id: this.localidadeNivel2Selecionada.id,
                    nome: `${this.localidadeNivel2Selecionada.nome}`,
                    codigo: 'LOCALIDADE2'
                };
                this.tags.push(localidadeNivel2);
                filtros.idNivel2 = this.localidadeNivel2Selecionada.id;
            } else {
                filtros.idNivel2 = '';
            }

            if (this.categorias.length === 0) {
                filtros.idsCategorias = [];
            }

            if (this.possuiRestricao !== null) {
                this.tags = this.tags.filter(
                    value => value.codigo !== 'POSSUI_RESTRICOES'
                );
                let valor =
                    this.possuiRestricao === 'POSSUI_RESTRICOES'
                        ? this.$t(
                              'mensagens.blocoAlerta.filtros.possuiRestricao'
                          )
                        : this.$t(
                              'mensagens.blocoAlerta.filtros.naoPossuiRestricao'
                          );

                this.tags.push({
                    valor: valor,
                    codigo: 'POSSUI_RESTRICOES'
                });
            }

            if (this.areasProtegidasSelecionadas.length > 0) {
                this.tags = this.tags.filter(
                    value => !value.codigo.startsWith('AREAS_PROTEGIDAS')
                );

                this.areasProtegidasSelecionadas.map(area => {
                    this.tags.push({
                        valor: area,
                        codigo: `AREAS_PROTEGIDAS-${area}`
                    });
                });
            }

            if (this.embargosDesmatamentosSelecionados.length > 0) {
                this.tags = this.tags.filter(
                    value => !value.codigo.startsWith('EMBARGOS_DESMATAMENTOS')
                );

                this.embargosDesmatamentosSelecionados.map(embargo => {
                    this.tags.push({
                        valor: embargo,
                        codigo: `EMBARGOS_DESMATAMENTOS-${embargo}`
                    });
                });
            }

            if (this.representantesSelecionados.length > 0) {
                this.tags = this.tags.filter(
                    value => !value.codigo.startsWith('REPRESENTANTES')
                );

                this.representantesSelecionados.map(representante => {
                    this.tags.push({
                        valor: representante + ' - pessoas',
                        codigo: `REPRESENTANTES-${representante}`
                    });
                });
            }

            if (this.socialSelecionados.length > 0) {
                this.tags = this.tags.filter(
                    value => !value.codigo.startsWith('SOCIAL')
                );

                this.socialSelecionados.map(social => {
                    this.tags.push({
                        valor: social,
                        codigo: `SOCIAL-${social}`
                    });
                });
            }

            this.tags.sort((a, b) => {
                const nomeA = a.nome || '';
                const nomeB = b.nome || '';

                return nomeA.localeCompare(nomeB);
            });

            this.$emit('atualizar-filtro-avancado', filtros, null);
        },

        abrirCollapse(ref) {
            if (ref) {
                try {
                    if (ref === 'restricaoSocioambiental') return;
                    const acao = this.acaoCollapse[ref];
                    if (!this[ref].length && typeof this[ref] !== 'string') {
                        this[acao.callback]();
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados.'
                    );
                    throw new Error(
                        'Ação não registrada para o collapse:' +
                            ref +
                            ', ERRRO:' +
                            error
                    );
                }
            }
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);

            this.desmarcarFiltroPopover(filtro);

            if (filtro.codigo === 'POSSUI_RESTRICOES') {
                this.possuiRestricao = null;
            }

            if (filtro.codigo.startsWith('AREAS_PROTEGIDAS-')) {
                this.areasProtegidasSelecionadas =
                    this.areasProtegidasSelecionadas.filter(
                        a => a !== filtro.valor
                    );
                if (this.areasProtegidasSelecionadas.length === 0) {
                    this.checkAllAreasProtegidas = false;
                    this.isIndeterminateAreasProtegidas = false;
                }
            }

            if (filtro.codigo.startsWith('EMBARGOS_DESMATAMENTOS-')) {
                this.embargosDesmatamentosSelecionados =
                    this.embargosDesmatamentosSelecionados.filter(
                        e => e !== filtro.valor
                    );
                if (this.embargosDesmatamentosSelecionados.length === 0) {
                    this.checkAllEmbargosDesmatamentos = false;
                    this.isIndeterminateEmbargosDesmatamentos = false;
                }
            }

            if (filtro.codigo.startsWith('REPRESENTANTES-')) {
                this.representantesSelecionados =
                    this.representantesSelecionados.filter(
                        r => r + ' - pessoas' !== filtro.valor
                    );
                if (this.representantesSelecionados.length === 0) {
                    this.checkAllRepresentantes = false;
                    this.isIndeterminateRepresentantes = false;
                }
            }

            if (filtro.codigo.startsWith('SOCIAL-')) {
                this.socialSelecionados = this.socialSelecionados.filter(
                    s => s !== filtro.valor
                );
                if (this.socialSelecionados.length === 0) {
                    this.checkAllSocial = false;
                    this.isIndeterminateSocial = false;
                }
            }

            this.aplicar();
        },

        desmarcarFiltroPopover(filtro) {
            this.biomasSelecionados = this.biomasSelecionados.filter(
                b => b.codigo !== filtro.codigo
            );
            this.resultadosSelecionados = this.resultadosSelecionados.filter(
                c => c.codigo !== filtro.codigo
            );
            if (filtro.codigo === 'LOCALIDADE0') {
                this.localidadeNivel0Selecionada = {};
            }
            if (filtro.codigo === 'LOCALIDADE1') {
                this.localidadeNivel1Selecionada = {};
            }
            if (filtro.codigo === 'LOCALIDADE2') {
                this.localidadeNivel2Selecionada = {};
            }
            if (filtro.codigo === 'CATEGORIA') {
                this.$emit('remover-categoria-selecionada', filtro.id);
                this.categorias = this.categorias.filter(
                    value => value.id !== filtro.id
                );
            }
        },

        selecionarResultado(resultado) {
            this.adicionarResultado(resultado);

            this.aplicar();
        },

        adicionarResultado(resultado) {
            const filtro = {
                id:
                    resultado.filtro.idTerritorio ||
                    resultado.filtro.idRepresentante,
                filtro: resultado.filtro,
                nome: resultado.valor
            };
            filtro.codigo = `${filtro.id}_${filtro.nome}`;

            const adicionado = this.resultadosSelecionados.find(
                c => c.codigo === filtro.codigo
            );

            if (!adicionado) {
                this.resultadosSelecionados.push(filtro);
            }
        },

        limpar() {
            this.mostrarResultado = false;
            this.resultadosPesquisa = [];
        },

        fecharLista() {
            setTimeout(() => {
                this.mostrarResultado = false;
                this.resultadosPesquisa = [];
            }, 300);
        },

        buscarBioma() {
            BiomaService.buscar()
                .then(({ data }) => {
                    setTimeout(() => {
                        this.biomas = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de biomas.'
                    );
                    throw error;
                });
        },

        buscarCamadasSocioambientais() {
            MonitoramentoSocioambientalService.buscarCamadasSocioambientais()
                .then(({ data }) => {
                    setTimeout(() => {
                        this.camadasSocioAmbientais = data;
                        this.camadasSocioAmbientais.map(camada => {
                            if (
                                camada.descricaoCategoria === 'Áreas protegidas'
                            ) {
                                this.areasProtegidas.push(camada);
                            }
                            if (
                                camada.descricaoCategoria ===
                                'Embargos e desmatamento'
                            ) {
                                this.embargosDesmatamentos.push(camada);
                            }
                            if (
                                camada.descricaoCategoria === 'Representantes'
                            ) {
                                this.representantes.push(camada);
                            }
                            if (camada.descricaoCategoria === 'Social') {
                                this.social.push(camada);
                            }
                        });
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de camadas socioambientais.'
                    );
                    throw error;
                });
        },

        buscarLocalidadeNivel0() {
            LocalidadeService.findNivel0()
                .then(({ data }) => {
                    setTimeout(() => {
                        this.localidadesNivel0 = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados dos países.'
                    );
                    throw error;
                });
        },

        buscarLocalidadeNivel1() {
            this.internacionalizarLocalidade();
            this.localidadeNivel2Selecionada = null;
            this.localidadesNivel2 = [];
            LocalidadeService.findNivel1(this.localidadeNivel0Selecionada.id)
                .then(({ data }) => {
                    this.localidadeNivel1Selecionada = null;
                    setTimeout(() => {
                        this.localidadesNivel1 = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de estados.'
                    );
                    throw error;
                });
        },

        buscarLocalidadeNivel2() {
            LocalidadeService.findNivel2(this.localidadeNivel1Selecionada.id)
                .then(({ data }) => {
                    this.localidadeNivel2Selecionada = null;
                    setTimeout(() => {
                        this.localidadesNivel2 = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de municipio.'
                    );
                    throw error;
                });
        },

        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },

        limparFiltros() {
            this.biomasSelecionados = [];
            this.resultadosSelecionados = [];
            this.localidadeNivel0Selecionada = {};
            this.localidadeNivel1Selecionada = {};
            this.localidadeNivel2Selecionada = {};
            this.categorias = [];

            this.tags.forEach(tag => {
                if (tag.codigo === 'CATEGORIA') {
                    setTimeout(() => {
                        this.$emit('remover-categoria-selecionada', tag.id);
                    }, 500);
                }
            });

            this.tags = [];
            this.idCamadas = [];
            this.areasProtegidasSelecionadas = [];
            this.embargosDesmatamentosSelecionados = [];
            this.representantesSelecionados = [];
            this.socialSelecionados = [];
            this.localidadesNivel1 = [];
            this.localidadesNivel2 = [];
            this.checkAllAreasProtegidas = false;
            this.isIndeterminateAreasProtegidas = false;
            this.checkAllEmbargosDesmatamentos = false;
            this.isIndeterminateEmbargosDesmatamentos = false;
            this.checkAllRepresentantes = false;
            this.isIndeterminateRepresentantes = false;
            this.checkAllSocial = false;
            this.isIndeterminateSocial = false;
            this.possuiRestricao = null;

            this.aplicar();
        },

        getNome(nome, valor, tag) {
            if (valor && valor.includes('- pessoas')) {

                const [nomeDaCamada] = valor
                    .split('- pessoas')
                    .map(s => s.trim());

                const camadaTraduzida = this.traduzirCamada(nomeDaCamada);

                const pessoasTraduzido = this.$t('mensagens.comuns.pessoas');

                return `${camadaTraduzida} - ${pessoasTraduzido}`;
            }

            if (nome !== undefined) {
                if (nome.includes('Representantes')) {
                    return this.$t('mensagens.comuns.pessoas');
                } else {
                    return this.traduzirCamada(nome);
                }
            } else {
                return this.traduzirCamada(valor);
            }
        },

        handleIdCamadas() {
            if (this.camadasSocioAmbientais) {
                const selecoes = [
                    ...this.areasProtegidasSelecionadas,
                    ...this.embargosDesmatamentosSelecionados,
                    ...this.socialSelecionados
                ];

                const idCamadasSet = new Set(this.idCamadas);

                this.camadasSocioAmbientais.forEach(camada => {
                    if (selecoes.includes(camada.codigoCamada)) {
                        idCamadasSet.add(camada.id);
                    } else {
                        idCamadasSet.delete(camada.id);
                    }
                });

                this.idCamadas = Array.from(idCamadasSet);
            }
        },

        handleIdCamadasRepresentantes() {
            if (this.camadasSocioAmbientais) {
                const selecoes = [...this.representantesSelecionados];

                const idCamadasRepresentantesSet = new Set(
                    this.idCamadasRepresentantes
                );

                this.camadasSocioAmbientais.forEach(camada => {
                    if (selecoes.includes(camada.codigoCamada)) {
                        idCamadasRepresentantesSet.add(camada.id);
                    } else {
                        idCamadasRepresentantesSet.delete(camada.id);
                    }
                });

                this.idCamadasRepresentantes = Array.from(
                    idCamadasRepresentantesSet
                );
            }
        },

        handleCheckAllAreasProtegidasChange(val) {
            if (val) {
                this.areasProtegidas.map(ares => {
                    this.areasProtegidasSelecionadas.push(ares.codigoCamada);
                });
            } else {
                this.areasProtegidasSelecionadas = [];
            }
            this.isIndeterminateAreasProtegidas = false;
        },

        handleAreasProtegidasSelecionadasChange(value) {
            let checkedCount = value.length;
            this.checkAllAreasProtegidas =
                checkedCount === this.areasProtegidas.length;
            this.isIndeterminateAreasProtegidas =
                checkedCount > 0 && checkedCount < this.areasProtegidas.length;
        },

        handleCheckAllEmbargosDesmatamentosChange(val) {
            if (val) {
                this.embargosDesmatamentos.map(ares => {
                    this.embargosDesmatamentosSelecionados.push(
                        ares.codigoCamada
                    );
                });
            } else {
                this.embargosDesmatamentosSelecionados = [];
            }
            this.isIndeterminateEmbargosDesmatamentos = false;
        },

        handleEmbargosDesmatamentosSelecionadosChange(value) {
            let checkedCount = value.length;
            this.checkAllEmbargosDesmatamentos =
                checkedCount === this.embargosDesmatamentos.length;
            this.isIndeterminateEmbargosDesmatamentos =
                checkedCount > 0 &&
                checkedCount < this.embargosDesmatamentos.length;
        },

        handleCheckAllRepresentantesChange(val) {
            if (val) {
                this.representantes.map(rep => {
                    this.representantesSelecionados.push(rep.codigoCamada);
                });
            } else {
                this.representantesSelecionados = [];
            }
            this.isIndeterminateRepresentantes = false;
        },

        handleRepresentantesSelecionadosChange(value) {
            let checkedCount = value.length;
            this.checkAllRepresentantes =
                checkedCount === this.representantes.length;
            this.isIndeterminateRepresentantes =
                checkedCount > 0 && checkedCount < this.representantes.length;
        },

        handleCheckAllSocialChange(val) {
            if (val) {
                this.social.map(sc => {
                    this.socialSelecionados.push(sc.codigoCamada);
                });
            } else {
                this.socialSelecionados = [];
            }
            this.isIndeterminateSocial = false;
        },

        handleSocialSelecionadosChange(value) {
            let checkedCount = value.length;
            this.checkAllSocial = checkedCount === this.social.length;
            this.isIndeterminateSocial =
                checkedCount > 0 && checkedCount < this.social.length;
        },

        traduzirCamada(camada) {
            const traducao = this.$t(`mensagens.camadas.${camada}`);
            return traducao.startsWith('mensagens.camadas.') ? camada : traducao;
        },

        internacionalizarLocalidade() {
            if (this.localidadeNivel0Selecionada.sigla === 'BR') {
                this.tituloLocalidadeNivel1 = this.$t('mensagens.blocoFiltros.uteis.uf');
                this.tituloLocalidadeNivel2 = this.$t('mensagens.blocoFiltros.uteis.municipio');
            }
            if (this.localidadeNivel0Selecionada.sigla === 'PY') {
                this.tituloLocalidadeNivel1 = this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel1');
                this.tituloLocalidadeNivel2 = this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel2');
            }
            if (this.localidadeNivel0Selecionada.sigla === 'AR') {
                this.tituloLocalidadeNivel1 = this.$t('mensagens.blocoFiltros.uteis.argentinaNivel1');
                this.tituloLocalidadeNivel2 = this.$t('mensagens.blocoFiltros.uteis.argentinaNivel2');
            }
        },

        placeholderPais() {
            if (this.ambientePy) {
                return this.$t(`mensagens.blocoFiltros.uteis.placeholderParaguai`);
            } else {
                return this.$t(`mensagens.blocoFiltros.uteis.placeholder`);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.filtrar-monitoramento-socioambiental-container {
    display: flex;
    justify-content: space-between;
}

.filtrar-monitoramento-socioambiental-input-container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.filtrar-monitoramento-socioambiental__resultado {
    position: absolute;
    width: 100%;
}

.filtrar-monitoramento-socioambiental__resultado__nome {
    margin: 0px 10px;
}

.filtrar-monitoramento-socioambiental__input {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.filtrar-monitoramento-socioambiental__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.filtrar-monitoramento-socioambiental__categoria {
    font-weight: bold;
}

.filtrar-monitoramento-socioambiental-filtro-selecionado {
    margin-top: 15px;
    min-height: 42px;
}

.filtrar-monitoramento-socioambiental-filtro-selecionado__titulo {
    font-size: 18px;
    font-weight: 100;
}

.filtrar-monitoramento-socioambiental-filtro-selecionado__tag {
    margin: 0px 5px 10px 5px;
}

.filtrar-monitoramento-socioambiental-filtro-selecionado__limpar {
    margin: 0px 5px 10px 5px;

    i {
        padding-left: 5px;
    }
}

.filtrar-monitoramento-socioambiental-filtro-selecionado__nenhum {
    margin-left: 5px;
    font-weight: 100;
    font-style: italic;
    font-size: 14px;
}

.filtrar-monitoramento-socioambiental-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .filtrar-monitoramento-socioambiental-popover-header__text {
        color: var(--primary);
        font-weight: 600;
        font-size: 16px;
        line-height: 14px;
    }

    .filtrar-monitoramento-socioambiental-popover-header__link {
        color: #1989fa;
        font-weight: 500;
        text-decoration: underline;
        cursor: pointer;
        font-size: 16px;
        line-height: 14px;
    }
}

.filtrar-monitoramento-socioambiental-popover-collapse {
    .el-select {
        width: 100%;
    }

    .el-collapse-item div p {
        font-size: 14px;
        margin-bottom: 0.5rem;
        font-weight: 500;
    }

    .el-collapse-item__header {
        font-weight: 500;
    }

    .filtro-accordion {
        margin-top: 10px;
    }

    .el-checkbox,
    .el-radio {
        margin-right: 12px !important;
        min-width: 200px;
        line-height: 2;
    }

    .el-radio {
        color: var(--primary);
        font-weight: 500;
        line-height: 16px;
    }
}

.filtrar-monitoramento-socioambiental-popover-collapse__select {
    display: flex;
    justify-content: flex-start;
    gap: 25px;
    min-height: 60px;
}

.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    background: transparent !important;
    display: flex;
    align-items: center;

    .lyra-filtro:before {
        content: '';
        width: 15px !important;
        height: 12px !important;
        background-color: var(--primary) !important;
        margin-right: 6px;
    }
}

.el-collapse-item__categorias--loading {
    min-height: 76px;
}

.el-collapse-item__possui-alertas {
    display: flex;
    gap: 24px;
}

.el-collapse-item__biomas--loading {
    min-height: 70px;
}

.el-collapse-restricoes--loading {
    min-height: 40px;
}

.el-collapse-item__camadas-socioambientais--loading {
    min-height: 530px;
    margin-left: 5px;
}

.el-tag {
    border-radius: 20px !important;
}

.el-tag.el-tag--success {
    border-color: var(--secondary-two) !important;
    color: var(--white) !important;
    background: var(--secondary-two) !important;
}

span.filtrar-monitoramento-socioambiental-filtro-selecionado__limpar.el-tag.el-tag--info.el-tag--light {
    cursor: pointer;
}
</style>

<style lang="scss">
.el-popover-monitoramento-socioambiental {
    font-family: 'Roboto', 'sans serif' !important;
    padding: 20px !important;
    max-height: 785px;
    margin-top: -12px !important;
    top: 213px !important;

    .el-divider--horizontal {
        margin: 12px 0;
    }

    .el-form {
        max-height: 785px;
    }

    .el-collapse-item__header {
        position: relative;
        padding: 22px 0px 22px 40px;
        color: #3b3b3b;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .el-collapse-item__arrow {
            font-weight: 600;
        }

        .el-collapse-item__arrow {
            position: absolute;
            left: 0px;
            font-size: 14px;
            font-weight: 600;
        }

        .item-container {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            .item-inside-order {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 100%;
            }
            .el-dialog__close {
                font-size: 18px !important;
                margin-right: 5px;
                color: #686868;
                z-index: 30;
            }

            .title-category {
                display: inline-block;
                font-size: 14px;
                font-weight: 500;
                vertical-align: middle;
                color: #434343;
            }
        }
    }

    .filtrar-monitoramento-socioambiental-popover-collapse {
        .el-collapse-item__content {
            padding-bottom: 0px;
        }
        .el-checkbox-group {
            -webkit-column-count: 2;
            -moz-column-count: 2;
            column-count: 2;
            -webkit-column-gap: 0px;
            -moz-column-gap: 0px;
            column-gap: 5px;
            width: 100%;
        }
        .el-checkbox-group {
            .el-checkbox__label {
                color: #00413c;
                font-weight: 500 !important;
                line-height: 16px !important;
                margin-bottom: 0px !important;
            }
        }
        .el-checkbox {
            margin-right: 0px !important;
            min-width: 250px;
            line-height: 2;

            .el-checkbox__label {
                font-size: 14px;
                font-weight: 500;
                line-height: 22px;
                letter-spacing: 0px;
                text-align: left;
                margin-bottom: 8px;
            }
        }
    }
}
</style>
